import { render, staticRenderFns } from "./ProductRowBig.vue?vue&type=template&id=176c4d59&scoped=true"
import script from "./ProductRowBig.vue?vue&type=script&lang=js"
export * from "./ProductRowBig.vue?vue&type=script&lang=js"
import style0 from "./ProductRowBig.vue?vue&type=style&index=0&id=176c4d59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176c4d59",
  null
  
)

export default component.exports